import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable, tap, throwError } from 'rxjs';
import { CardType } from '../enums/card-type.enum';

@Injectable({ providedIn: 'root' })
export class GlobalDataService {
	pwa$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	pwaInfo$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	pwaLogo$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	pwaImage$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	subdomain$: BehaviorSubject<string> = new BehaviorSubject<string>('');
	pwaTheme$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	addCardsStep$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	selectedCard$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	selectedMachine$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	purchaseAmount$: BehaviorSubject<number | null> = new BehaviorSubject<number | null>(null);
	cards$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	newCardInfo$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	newCardType$: BehaviorSubject<CardType | null> = new BehaviorSubject<CardType | null>(null);

	clearData() {
		this.pwa$.next(null);
		this.pwaInfo$.next(null);
		this.pwaImage$.next(null);
		this.pwaLogo$.next(null);
		this.subdomain$.next('');
		this.cards$.next(null);
		this.selectedCard$.next(null);
		this.newCardInfo$.next(null);
		this.newCardType$.next(null);
	}
}
